import React from "react";

import { useWidget } from "@/lib/hooks/use-widget";
import { useTotalBalance } from "@/lib/hooks/use-total-balance";
import { IconSell } from "@/lib/components/icons/sell";
import { IconSwap } from "@/lib/components/icons/swap";
import { IconBuy } from "@/lib/components/icons/buy";
import { IconSend } from "@/lib/components/icons/send";
import { IconReceive } from "@/lib/components/icons/receive";

const ShortcutButtons = () => {
  const { redirectUrl } = useWidget();
  const totalBalance = useTotalBalance();

  const links = [
    {
      label: "Buy",
      icon: IconBuy,
      url: `/dashboard/buy/`,
    },
    ...(totalBalance > 0
      ? [
          {
            label: "Sell",
            icon: IconSell,
            url: `/dashboard/sell/`,
          },
          {
            label: "Swap",
            icon: IconSwap,
            url: `/dashboard/swap/`,
          },
          {
            label: "Send",
            icon: IconSend,
            url: `/dashboard/?send=true`,
          },
        ]
      : []),
    {
      label: "Receive",
      icon: IconReceive,
      url: `/dashboard/?receive=true`,
    },
  ];

  return (
    <>
      {links.map(({ label, icon: Icon, url }) => (
        <a
          key={label}
          href={`${redirectUrl}${url}`}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full text-center flex flex-col items-center"
        >
          <div className="h-10 w-10 p-1.5 bg-primary rounded-full text-primary-foreground mb-1 flex items-center justify-center">
            <Icon className="w-5 h-5" size={20} />
          </div>
          <span className="font-bold text-xs">{label}</span>
        </a>
      ))}
    </>
  );
}; 

export default ShortcutButtons;
